import type { SalesforceProduct } from '@/types/salesforce';

export interface ProductAgeThresholds {
  pediatricMaxAgeMonths: number;
  minorMaxAge: number;
  under45MaxAge: number;
  over60MinAge: number;
}

export interface ProductConfiguration {
  ageThresholds: ProductAgeThresholds;
  products: {
    signature: SalesforceProduct;
    under45: SalesforceProduct;
    over60: SalesforceProduct;
  };
}

export const PRODUCT_CONFIG: ProductConfiguration = {
  ageThresholds: {
    pediatricMaxAgeMonths: 4, // Under 5 months threshold
    minorMaxAge: 17, // Under 18 threshold
    under45MaxAge: 44, // Under 45 threshold
    over60MinAge: 61, // Over 60 threshold
  },
  products: {
    signature: 'Signature',
    under45: 'Under-45',
    over60: 'Over 60',
  },
} as const;
